// extracted by mini-css-extract-plugin
export var basicLicenceTabStructure = "basic-licence-tab-structure_R0V7GQxtTpwuM5HKRYqN";
export var basicLicenceTabStructureContent = "basic-licence-tab-structure__content_SlkLaJSB0Lrpb84BdbA4";
export var basicLicenceTabStructureHeader = "basic-licence-tab-structure__header_VTtjXDyk1UH_dWpLsgcx";